import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { COMPARE_ROWS, type CompareValue } from "./content";

function Value({ value, highlight }: { value: CompareValue; highlight: boolean }): JSX.Element {
  if (value === "sim") {
    return (
      <>
        <Check size={18} className={highlight ? "text-signal" : "text-foreground/80"} aria-hidden="true" />
        <span className="sr-only">Sim</span>
      </>
    );
  }
  if (value === "nao-encontrado") {
    return <span className="text-xs leading-snug text-muted-foreground">Não encontramos no site</span>;
  }
  return <span className={cn("text-sm font-medium", highlight && "text-signal")}>{value}</span>;
}

export function Comparativo(): JSX.Element {
  return (
    <section id="comparativo" aria-labelledby="comparativo-heading" className="scroll-mt-20 border-t border-border">
      <div className="mx-auto max-w-[65rem] px-4 py-24 sm:px-6 lg:px-8">
        <h2
          id="comparativo-heading"
          className="max-w-[22ch] text-[clamp(2rem,1.4rem+2.2vw,3.25rem)] font-bold leading-[1.05] tracking-[-0.035em]"
        >
          O que o easyfy faz, o LucraLink também faz.
        </h2>

        <div className="mt-12 overflow-hidden rounded-2xl border border-border-strong">
          <table className="w-full border-collapse text-left">
            <caption className="sr-only">Comparativo de recursos entre LucraLink e Easyfy</caption>
            <thead>
              <tr className="border-b border-border-strong text-sm">
                <th scope="col" className="px-4 py-4 font-medium text-muted-foreground sm:px-6">
                  Recurso
                </th>
                <th scope="col" className="w-[26%] bg-signal-dim/40 px-3 py-4 text-center font-semibold sm:w-[20%]">
                  LucraLink
                </th>
                <th scope="col" className="w-[26%] px-3 py-4 text-center font-medium text-muted-foreground sm:w-[20%]">
                  Easyfy
                </th>
              </tr>
            </thead>
            <tbody>
              {COMPARE_ROWS.map((row) => (
                <tr key={row.label} className="border-b border-border last:border-b-0">
                  <th scope="row" className="px-4 py-4 text-sm font-normal leading-snug text-foreground sm:px-6 sm:text-[0.9375rem]">
                    {row.label}
                  </th>
                  <td className="bg-signal-dim/40 px-3 py-4">
                    <div className="flex justify-center text-center">
                      <Value value={row.lucralink} highlight />
                    </div>
                  </td>
                  <td className="px-3 py-4">
                    <div className="flex justify-center text-center">
                      <Value value={row.easyfy} highlight={false} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="mt-5 max-w-[70ch] text-sm leading-relaxed text-muted-foreground">
          Coluna Easyfy montada com o que o site público do easyfy.click declarava em outubro de 2026.
          Viu algo desatualizado?{" "}
          <a href="/contato/" className="text-foreground underline underline-offset-4 hover:text-signal">
            Avise a gente
          </a>{" "}
          e corrigimos.
        </p>
      </div>
    </section>
  );
}
